export const solutions = [
  {
    id: 'rd', asset: 'demo5', number: '01', category: 'PROGETTI & RISORSE', icon: 'projects',
    title: 'R&D & Rendicontazione',
    description: 'Gestione centralizzata di progetti, attività, risorse, ore, pianificazione e budget.',
    tags: ['Progetti', 'Pianificazione', 'Budget'],
    does: 'Centralizza gestione dei progetti, pianificazione delle attività e rendicontazione.',
    features: ['Progetti', 'Gantt', 'Pianificazione', 'Rendicontazione ore', 'Risorse', 'Budget', 'Consuntivi', 'Dashboard', 'Report'],
    benefit: 'Riduce la frammentazione delle informazioni e permette di controllare progetti, ore, risorse e budget da un unico ambiente.'
  },
  {
    id: 'quality', asset: 'demo2', number: '02', category: 'DOCUMENTI & PROCESSI', icon: 'quality',
    title: 'Qualità & ISO 9001',
    description: 'Gestione digitale di documenti, procedure, registrazioni, certificazioni e informazioni del sistema qualità.',
    tags: ['Documenti', 'Procedure', 'Certificazioni'],
    does: 'Organizza la documentazione del sistema qualità in un ambiente digitale centralizzato.',
    features: ['Documenti', 'Procedure', 'Registrazioni', 'Certificazioni', 'Fornitori', 'Ricerca', 'Scadenze', 'Revisioni'],
    benefit: 'Permette di trovare e controllare più facilmente documenti e informazioni mantenendo una struttura ordinata.'
  },
  {
    id: 'meeting', asset: 'demo4', number: '03', category: 'INTELLIGENZA ARTIFICIALE', icon: 'meeting',
    title: 'AI Meeting Assistant',
    description: 'Registrazione, trascrizione e organizzazione automatica delle informazioni emerse durante una riunione.',
    tags: ['Trascrizione', 'Sintesi AI', 'Verbali'],
    does: 'Trasforma una riunione in informazioni organizzate e utilizzabili.',
    features: ['Registrazione', 'Trascrizione', 'Identificazione interlocutori', 'Sintesi', 'Punti chiave', 'Decisioni', 'Azioni', 'Verbale'],
    benefit: 'Riduce il lavoro manuale successivo alle riunioni e facilita il recupero delle informazioni importanti.'
  },
  {
    id: 'business', asset: 'demo3', number: '04', category: 'DATI & DECISIONI', icon: 'business',
    title: 'Gestione aziendale & Controllo',
    description: 'Dashboard e strumenti personalizzati per organizzare e interpretare dati economici e operativi.',
    tags: ['Dashboard', 'KPI', 'Controllo di gestione'],
    does: 'Organizza dati economici e operativi attraverso dashboard e strumenti personalizzati.',
    features: ['Prima Nota', 'Entrate', 'Uscite', 'KPI', 'EBITDA', 'Analisi costi', 'Scadenze', 'Report'],
    benefit: 'Trasforma dati distribuiti in informazioni immediatamente consultabili.'
  },
  {
    id: 'events', asset: 'demo1', number: '05', category: 'CONNESSIONI & OPPORTUNITÀ', icon: 'events',
    title: 'QR, Eventi & Lead Generation',
    description: 'QR code, landing page e strumenti digitali per eventi, raccolta contatti e attività commerciali.',
    tags: ['QR code', 'Eventi', 'Contatti'],
    does: "Collega QR code, landing page, eventi e raccolta contatti in un unico flusso digitale.",
    features: ['QR code', 'Landing page', 'Moduli', 'Raccolta contatti', 'Eventi', 'Statistiche', 'Esportazioni'],
    benefit: "Permette di trasformare un'interazione fisica o un evento in un contatto digitale facilmente gestibile."
  }
];
